<template>
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>รหัสไปรษณีย์*</span>
      <el-select
        :value="addressForm.zip_code"
        :remote-method="handleSearchZipCode"
        clearable
        filterable
        remote
        @input="handleChangeAddressForm('zip_code', $event)"
      >
        <el-option v-for="code in zipCodes" :key="code" :value="code">{{
          code
        }}</el-option>
      </el-select>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>จังหวัด*</span>
      <el-select
        :value="addressForm.province_code"
        value-key="province_code"
        label-key="provice_name"
        @input="handleChangeAddressForm('province_code', $event)"
      >
        <el-option
          v-for="p in provinces"
          :key="p.province_code"
          :value="p.province_code"
          :label="p.province_name"
          >{{ p.province_name }}</el-option
        >
      </el-select>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>เขต/อำเภอ*</span>
      <el-select
        :value="addressForm.amphur_code"
        @input="handleChangeAddressForm('amphur_code', $event)"
      >
        <el-option
          v-for="a in amphurs"
          :key="a.amphur_code"
          :value="a.amphur_code"
          :label="a.amphur_name"
          >{{ a.amphur_name }}</el-option
        >
      </el-select>
    </div>
    <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 detail">
      <span>แขวง/ตำบล*</span>
      <el-select
        :value="addressForm.tumbon"
        value-key="tumbon_code"
        label-key="tumbon_name"
        @input="handleChangeAddressForm('tumbon', $event)"
      >
        <el-option
          v-for="t in selectableTumbons"
          :key="t.tumbon_code"
          :value="t"
          :label="t.tumbon_name"
          >{{ t.tumbon_name }}</el-option
        >
      </el-select>
    </div>
    <div class="col-12 detail">
      <span>ที่อยู่*</span>
      <el-input
        :value="addressForm.address"
        type="textarea"
        @input="handleChangeValue('address', $event)"
      ></el-input>
    </div>
  </div>
</template>

<script>
import { Input, Select, Option } from "element-ui";
import { baanRueJaiClient } from "@/dependencies";
import * as R from "ramda";

// Validation function that checks if all required properties are present
function isValid(obj) {
  return (
    obj.amphur_code &&
    obj.amphur_name &&
    obj.amphur_name_en &&
    obj.pre_amphur &&
    obj.pre_amphur_en &&
    obj.pre_tumbon &&
    obj.pre_tumbon_en &&
    obj.province_code &&
    obj.province_name &&
    obj.province_name_en &&
    obj.tumbon_code &&
    obj.tumbon_name &&
    obj.tumbon_name_en &&
    obj.zip_code
  );
}

export default {
  name: 'AddressAutoFillSelector',
  components: {
    "el-input": Input,
    "el-select": Select,
    "el-option": Option,
  },
  props: {},
  data() {
    const addressForm = {
      zip_code: null,
      province_code: null,
      amphur_code: null,
      tumbon: null,
      address: null,
    };

    return {
      addressForm,
      initialTumbons: [],
      searchTumbons: null,
    };
  },
  computed: {
    tumbons() {
      return this.searchTumbons || this.initialTumbons;
    },
    zipCodes() {
      if (!this.tumbons.length) {
        return [];
      }

      // Get unique objects based on zip_code
      const uniqueArr = this.tumbons.filter(
        (obj, index, self) =>
          index === self.findIndex((o) => o.zip_code === obj.zip_code)
      );

      // Filter out invalid objects
      const filteredArr = uniqueArr.filter(isValid);

      return R.pipe(R.map(R.path(["zip_code"])), R.uniq)(filteredArr);
    },
    provinces() {
      return R.uniqBy(R.path(["province_code"]), this.tumbons);
    },
    amphurs() {
      if (!this.addressForm.province_code) {
        return [];
      }

      const filtered = this.tumbons.filter(
        (t) => t.province_code === this.addressForm.province_code
          && t.zip_code === this.addressForm.zip_code
      );

      return R.uniqBy(R.path(["amphur_code"]), filtered);
    },
    selectableTumbons() {
      if (!this.addressForm.amphur_code) {
        return [];
      }

      return this.tumbons.filter((t) => (
          t.amphur_code === this.addressForm.amphur_code &&
          t.zip_code === this.addressForm.zip_code
        ));
    },
  },
  methods: {
    async setup() {
      await this.setupData();
    },
    async setupData() {
      await this.setupInitialTumbons();
    },
    async handleChangeAddressForm(key, value) {
      this.addressForm[key] = value;

      if (key === "zip_code") {
        this.handleChangeAddressZipCodeForm(value);
        this.handleChangeAddressAmphurCodeForm(value);
      } else if (key === "amphur_code") {
        this.handleChangeAddressAmphurCodeForm(value);
      }

      this.$emit("input", {
        ...this.addressForm
      });
    },
    async handleChangeAddressZipCodeForm(val) {
      if (!val) {
        this.addressForm.province_code = null;
        this.addressForm.amphur_code = null;
        this.addressForm.tumbon = null;
        return;
      }

      switch (this.provinces.length) {
        case 1:
          this.addressForm.province_code = this.provinces[0].province_code;
          break;
        default:
          this.addressForm.province_code = null;
          break;
      }

      switch (this.amphurs.length) {
        case 1:
          this.addressForm.amphur_code = this.amphurs[0].amphur_code;
          break;
        default:
          this.addressForm.amphur_code = null;
          break;
      }

      switch (this.selectableTumbons.length) {
        case 1: {
          const [tumbon] = this.selectableTumbons;
          this.addressForm.tumbon = tumbon;
          break;
        }
        default:
          this.addressForm.tumbon = null;
          break;
      }
    },
    async handleChangeAddressAmphurCodeForm(val) {
      if (!val) {
        return;
      }

      switch (this.selectableTumbons.length) {
        case 1: {
          const [tumbon] = this.selectableTumbons;
          this.addressForm.tumbon = tumbon;
          break;
        }
        default:
          this.addressForm.tumbon = null;
          break;
      }
    },
    async handleSearchZipCode(queryString) {
      const params = { zip_code: queryString };
      const response = await baanRueJaiClient.admin.addresses.list(params);

      this.searchTumbons = response.data.result;
    },
    async setupInitialTumbons() {
      const zipCode = this.rawReceipt?.home?.zip_code;
      if (!zipCode) return;

      const params = { zip_code: zipCode };
      const response = await baanRueJaiClient.admin.addresses.list(params);
      this.initialTumbons = response.data.result;
    },
    handleChangeValue(key, value) {
      this.addressForm[key] = value;
      this.$emit("input", { ...this.addressForm });
    }
  },
};
</script>

<style lang="scss" scoped>
.label {
  font-size: 14px;
  color: #777;
}

.detail {
  padding-top: 10px;
}

.el-select,
el-select,
el-option {
  width: 100%;
}

span {
  font-size: 14px;
}
</style>